let resumeData = {
  imagebaseurl: "https://github.com/Cohey072/",
  facebook: "https://www.facebook.com/okamoto.kohei.0727",
  name: "Kohei Okamoto",
  role: "Backend, Frontend, and Infrastructure engineer",
  roleDescription:
    "I love all of technologies. " +
    "As well as software and hardware, biology, physics, chemistry. " +
    "I welcome all the benefits brought by them. ",
  socialLinks: [
    {
      name: "facebook",
      url: "https://www.facebook.com/okamoto.kohei.0727",
      className: "fa fa-facebook"
    },
    {
      name: "github",
      url: "https://github.com/Cohey0727",
      className: "fa fa-github"
    },
    {
      name: "twitter",
      url: "https://twitter.com/cohey0727",
      className: "fa fa-twitter"
    }
  ],
  aboutme:
    "I am currently working at hokan corporation. " +
    "My job is backend, front and infrastructure engineer. " +
    "I'm busy everyday, I'm having a great time!",
  address: "Japan",
  website: "https://www.facebook.com/okamoto.kohei.0727",
  education: [
    {
      UniversityName: "Osaka University",
      specialization: "Engineering Science",
      MonthOfPassing: "Apr",
      YearOfPassing: "2016",
      Achievements: "Electronic physics"
    }
  ],
  work: [
    {
      CompanyName: "WorksApplications",
      CompanyURL: "https://www.worksap.co.jp",
      specialization: "SIer",
      MonthOfLeaving: "Oct",
      YearOfLeaving: "2018",
      Achievements: "Attendance Management System Operation"
    },
    {
      CompanyName: "hokan",
      CompanyURL: "https://hkn.jp",
      specialization: "Backend, Frontend, and Infrastructure engineer",
      MonthOfLeaving: "",
      YearOfLeaving: "Currently enrolled",
      Achievements: "Some Achievements"
    }
  ],
  skillsDescription: "My skills",
  skills: [
    {
      skillname: "HTML5",
      percentage: 85
    },
    {
      skillname: "CSS",
      percentage: 80
    },
    {
      skillname: "React(JS)",
      percentage: 75
    },
    {
      skillname: "Java",
      percentage: 55
    },
    {
      skillname: "Django(Python)",
      percentage: 60
    },
    {
      skillname: "MySQL",
      percentage: 50
    },
    {
      skillname: "Oracle",
      percentage: 45
    },
    {
      skillname: "Rails(Ruby)",
      percentage: 40
    }
  ],
  portfolio: [
    // {
    //   name: "project1",
    //   description: "hokan",
    //   imgurl: "images/portfolio/phone.jpg"
    // }
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy"
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy"
    }
  ]
};

export default resumeData;
